<script setup lang="ts">
import { Separator } from '@collector/shared-ui'
import { getEventTime, ParticipantName } from '@collector/shared-ui-domain'
import { Incident } from '@collector/sportsapi-client'
import {
  useParticipantById,
  useTeamSides,
} from '@desktop/views/Relation/composables'
import { useIncidentName } from '@desktop/views/Relation/Sports/composables'

import IncidentContainer from '../IncidentContainer.vue'
import IncidentEventStatus from '../IncidentEventStatus.vue'
import IncidentTime from '../IncidentTime.vue'

interface Props {
  incident: Incident
}

const props = defineProps<Props>()

// composables
const { getIncidentTeamSide } = useTeamSides()
const { participant } = useParticipantById(
  () => props.incident.participant_team_id,
)
const { getIncidentName } = useIncidentName()

// data
const incidentTeamSide = getIncidentTeamSide(props.incident)
</script>

<template>
  <IncidentContainer
    class="flex h-10 items-center px-3 py-2 text-sm"
    :incident
    :teamSide="incidentTeamSide"
  >
    <IncidentTime :incident />
    <Separator
      class="mx-4"
      vertical
    />
    <IncidentEventStatus :incident />

    <span class="mx-2 font-bold">
      {{ getEventTime(incident) }}
    </span>

    <Separator
      class="mx-4"
      vertical
    />

    <ParticipantName
      v-if="participant"
      class="font-bold"
      :participant
      withTeamColors
    />

    <span class="ml-4 font-bold">
      {{ getIncidentName(incident.incident_id) }}
    </span>
  </IncidentContainer>
</template>
